module.exports = __webpack_public_path__ + "media/received_chat.63bac2df.mp3";